import React from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import ErrorBoundary from '@fs/zion-error-boundary'
import Routes from './Routes'
import useCensusPermission from './hooks/useCensusPermission'
import useReportsAccess from './hooks/useReportsAccess'
import useAdminAccess from './hooks/useAdminAccess'
import AppTabs from './components/AppTabs'
import { VerifyPlacesProvider } from './providers/VerifyPlacesProvider'

function App() {
  const labsFF = useFeatureFlag('give_labs')
  const { hasCensusPermission } = useCensusPermission()
  const { authorized, error, loading } = useReportsAccess()
  const { authEnabled, error: adminAccessError, loading: adminAccessLoading, searchEnabled } = useAdminAccess()

  const showReports = !loading && authorized && !error
  const showAdmin = (authEnabled && searchEnabled && !adminAccessError && !adminAccessLoading) || false

  return (
    <ErrorBoundary>
      <AppTabs showReports={showReports} showAdmin={showAdmin} showLabs={labsFF.isOn} />
      <VerifyPlacesProvider>
        <Routes hasCensusPermission={hasCensusPermission} />
      </VerifyPlacesProvider>
    </ErrorBoundary>
  )
}

export default App
